.voice {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.play {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: var(--on-fill);
  background: var(--fill);
  background-image: var(--fill-gradient);
  box-shadow: 0 0 0 1.5px var(--fill-ring), 0 6px 14px var(--fill-glow);
  transition: transform 0.15s;
}

.play:active {
  transform: scale(0.92);
}

.play:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.play:disabled {
  opacity: 0.45;
  cursor: default;
}

.play svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

.hero .play {
  width: 52px;
  height: 52px;
}

.hero .play svg {
  width: 22px;
  height: 22px;
}

.compact .play {
  width: 34px;
  height: 34px;
}

.compact .play svg {
  width: 15px;
  height: 15px;
}

.body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.wave {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 30px;
  min-width: 0;
  overflow: hidden;
  cursor: pointer;
  touch-action: none;
}

.hero .wave {
  height: 40px;
}

.compact .wave {
  height: 24px;
}

.wave i {
  flex: 1 1 0;
  min-width: 1px;
  max-width: 3px;
  border-radius: 2px;
  background: color-mix(in srgb, var(--muted) 38%, transparent);
  transition: background-color 0.12s;
}

.mine .wave i {
  background: color-mix(in srgb, var(--text) 26%, transparent);
}

.wave i.played,
.mine .wave i.played {
  background: var(--accent);
}

.info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11.5px;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
  min-height: 18px;
}

.unheard {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent);
}

.grow {
  flex: 1;
}

.speed {
  all: unset;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--pill-bg);
  color: var(--accent);
  line-height: 18px;
}

.speed:focus-visible {
  outline: 2px solid var(--accent);
}
